const authorizedPickingChainUsers = [
  'daniel.garrido@foodforjoe.es',
  'almacen.massanes@foodforjoe.es',
  'sonia.cortes@foodforjoe.es',
];

export default authorizedPickingChainUsers;
